import React, { useState, useEffect } from "react";
import { IonButton } from "@ionic/react";

// Random number generator
const getRandomNumber = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;

// Dynamic word problem generator
const generateFractionProblem = () => {
    // Object categories
    const objects = ["pizza", "cake", "chocolate bar", "apple", "orange", "cookie", "sandwich", "watermelon slice", "mango"];
    const actions: { [key: string]: string } = { "ate": "eat", "gave away": "give away", "lost": "lose", "shared": "share", "took": "take" };
    const names: { [key: string]: string } = { "Rohan": "He", "Mia": "She", "Sarah": "She", "John": "He", "Arjun": "He", "Riya": "She", "Sam": "He", "Lina": "She", "David": "He", "Ananya": "She" };

    // Select random object, action, and name
    const object = objects[Math.floor(Math.random() * objects.length)];
    const action = Object.keys(actions)[Math.floor(Math.random() * Object.keys(actions).length)];
    const keys = Object.keys(names);
    const name = keys[Math.floor(Math.random() * keys.length)];

    // Generate total and part values (ensuring part < total)
    const total = getRandomNumber(4, 12);
    const part = getRandomNumber(1, total - 1);

    // Handle singular/plural grammar for objects
    const objectText = total === 1 ? object : `${object}s`;
    const pieceText = part === 1 ? "piece" : "pieces";

    // Construct both possible questions
    const question1 = `${name} has ${total} ${objectText}. ${names[name]} ${action} ${part} ${pieceText}. What fraction of the ${objectText} is left?`;
    const correctAnswer1 = `${total - part}/${total}`;

    const question2 = `${name} has ${total} ${objectText}. ${names[name]} ${action} ${part} ${pieceText}. What fraction of the ${objectText} did ${names[name].toLocaleLowerCase()} ${actions[action]}?`;
    const correctAnswer2 = `${part}/${total}`;

    // Randomly select either question1 or question2
    const isFirstQuestion = Math.random() < 0.5;
    return isFirstQuestion
        ? { question: question1, correctAnswer: correctAnswer1 }
        : { question: question2, correctAnswer: correctAnswer2 };
};

const FractionWordProblems: React.FC = () => {
    const [question, setQuestion] = useState<string>("");
    const [correctAnswer, setCorrectAnswer] = useState<string>("");
    const [options, setOptions] = useState<string[]>([]);
    const [message, setMessage] = useState<string>("");
    const [showImage, setShowImage] = useState(false);

    // Generate a new dynamic question
    const generateNewQuestion = () => {
        const { question, correctAnswer } = generateFractionProblem();

        // Generate 3 incorrect options dynamically
        const incorrectOptions = new Set<string>();
        while (incorrectOptions.size < 3) {
            const wrongTotal = getRandomNumber(4, 12);
            const wrongPart = getRandomNumber(1, wrongTotal - 1);
            const wrongFraction = `${wrongPart}/${wrongTotal}`;
            if (wrongFraction !== correctAnswer) {
                incorrectOptions.add(wrongFraction);
            }
        }

        // Mix correct answer with incorrect ones
        const allOptions = [...Array.from(incorrectOptions), correctAnswer].sort(() => Math.random() - 0.5);

        setQuestion(question);
        setCorrectAnswer(correctAnswer);
        setOptions(allOptions);
        setMessage("");
    };

    useEffect(() => {
        generateNewQuestion();
        document.title = "Mamas Guidance - Class One - Mathematics - Fraction - Word Problem"; // Set page title
    }, []);

    const checkAnswer = (selected: string) => {
        if (selected === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setShowImage(false);
                generateNewQuestion();
            }, 3000);
        } else {
            setMessage("❌ Oops! Try again");
        }
    };

    return (
        <>
            {!showImage ? (
                <div className="contentPart showCenter additionWord" style={{ padding: "0%" }}>
                    <h3 style={{padding: "5%"}}>{question}</h3>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap", marginTop: "20px" }}>
                        {options.map((option, index) => (
                            <div className="background-blue" key={index} onClick={() => checkAnswer(option)}
                            style={{ width: 'auto', padding: '10px', fontSize: '20px' }}
                            >
                                {option}
                            </div>
                        ))}
                    </div>
                    <p style={{ fontSize: "18px", marginTop: "10px" }}>{message}</p>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: '150px' }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default FractionWordProblems;
